import "./WhyClifRock.module.css";
import Header from "@/reusable_sections/Header";
import TheMasonryRevolution from "./sections/TheMasonryRevolution";
import SolvingContractorChallenges from "./sections/SolvingContractorChallenges";
import ReadyToUpgrade from "./sections/ReadyToUpgrade";
import Footer from "@/reusable_sections/Footer";
export default function WhyClifRockPage() {
  return <div>
      <Header />
      <TheMasonryRevolution />
      <SolvingContractorChallenges />
      <ReadyToUpgrade />
      <Footer />
    </div>;
}